import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

import InfoCard from "../components/InfoCard"
import StenaInfinityModule from "../images/InfinityMaxCam_WIND_rotor_1-removebg.jpg"
import StenaInfinityModule2 from "../images/InfinityMaxCam_WIND_rotor_1-removebg.jpg"
import InfoPageBG from "../components/InfoPageBG"
import { useStaticQuery, graphql} from "gatsby"

const SubPage = ({data}) => {

  const infoCard = data.strapiInfoCard
  
  return (
  <Layout>
    <Seo 
    title={infoCard.infocardseo?.metaTitle}
    description={infoCard.infocardseo?.metaDescription}
    />

    <InfoPageBG bgimage={infoCard.BackgroundImage.url}>
      <InfoCard
        heading={infoCard.Heading}
        intro={infoCard.Subheading}
        image={infoCard.Image?.url}
        imgalt={infoCard.Heading}
        content={infoCard.Content1}
      />
    </InfoPageBG>
  </Layout>
      )
      }

export const infoCardQuery = graphql`
query InfoCardQuery($slug: String!) {
  strapiInfoCard(slug: { eq: $slug }) {
    Content1
    FeaturedInfo
    Heading
    Subheading
    Title
    slug
    strapiId
    Image {
      url
    }
    BackgroundImage {
      url
    }
    infocardseo {
      metaTitle
      metaDescription
    }
  }
}
`

export default SubPage
